import { useState, useRef, useEffect, useMemo } from "react"
import styles from './LubematchSearch.module.css'
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { lubeMatchAPI } from "../../../api/api";
import { searchWithDynamicQuery } from "../../../api/lubematchAPI";
import { Toast } from 'primereact/toast';
import { debounce } from 'lodash';
import { LubematchRecommendation } from "../LubematchRecommendation/LubematchRecommendation";
import { Dropdown } from 'primereact/dropdown';
import {mapFacetToOptions} from '../../../common/Helpers/shellOptionsMapper';
import { se } from "date-fns/locale";

export const LubematchSearch = ({}) => {
    const [searchVinNumberField, setSearchVinNumberField] = useState('')
    const [loading, setLoading] = useState(false)

    const [carSeriesOptions, setCarSeriesOptions] = useState([]);
    const [selectedCarSeriesOption, setSelectedCarSeriesOption] = useState(null);

    const [fuelTypeOptions, setFuelTypeOptions] = useState([]);
    const [selectedFuelTypeOption, setSelectedFuelTypeOption] = useState(null);

    const [engineDisplacementOptions, setEngineDisplacementOptions] = useState([]);
    const [selectedEngineDisplacementOption,setSelectedEngineDisplacementOption] = useState(null);

    const [carMakeYearOptions, setCarMakeYearOptions] = useState([]);
    const [selectedCarMakeYearOption, setSelectedCarMakeYearOption] =useState(null);

    const [detailSearchMode, setDetailSearchMode] = useState(false);

    const [searchModelField, setSearchModellField] = useState()
    const [searchedCarListByModel, setSearchedCarListByModel] = useState([])

    const [currentCar, setCurrentCar] = useState(null)

    const [recommendationList, setRecommendationList] = useState([])
    const [hasSearchedRecommendations, setHasSearchedRecommendations] = useState(false)
    const [recommendationLoading, setRecommendationLoading] = useState(false)

    const toast = useRef(null);

    const debouncedSearch = useMemo(
        () =>
        debounce(async (value) => {
            const q = (value || '').trim();
            if (!q) {
                setSearchedCarListByModel([]);
                setCurrentCar(null);
                return;
            }
            await searchFromShell(
                q,
                selectedCarSeriesOption,
                selectedFuelTypeOption,
                selectedEngineDisplacementOption,
                selectedCarMakeYearOption
            );
        }, 500),
        [
            selectedCarSeriesOption,
            selectedFuelTypeOption,
            selectedEngineDisplacementOption,
            selectedCarMakeYearOption
        ]
    );

    useEffect(() => {
        debouncedSearch(searchModelField);
        return () => {
            debouncedSearch.cancel();
        }; 

    }, [searchModelField, debouncedSearch, selectedCarMakeYearOption, selectedCarSeriesOption, selectedEngineDisplacementOption, selectedFuelTypeOption ]);

    useEffect(() => {
        setSelectedCarSeriesOption(null);
        setSelectedFuelTypeOption(null);
        setSelectedEngineDisplacementOption(null);
        setSelectedCarMakeYearOption(null);
        setHasSearchedRecommendations(false);
    }, [searchModelField]);

    const onClickVinNumberSearch = async () => {
        if (searchVinNumberField.length < 3) {
            toast.current.show({ severity: 'warn', summary: 'Увага', detail: 'Довжина не може бути менше 3', life: 3000 });
            return;
        }

        setLoading(true);
        const resultJson = await lubeMatchAPI.searchCarByVinNumber(searchVinNumberField);
        setLoading(false);
        const result = JSON.parse(resultJson.data);
        const carList = result.data;

        if (carList.length) {
            const car = carList[0];
            const searchFirstString = `${car.CarBrand} ${car.CarModel} ${car.CarMakeYear} ${car.EngineVolumeL.toFixed(1)}`;
            const shellFirstSearchResult = await searchFromShell(searchFirstString)
            if (shellFirstSearchResult.equipment_list?.equipment.length) {
                setSearchModellField(searchFirstString)
                return;
            } else {
                const searchSecondString = `${car.CarBrand} ${car.CarModel} ${car.EngineVolumeL.toFixed(1)}`;
                const shellSecondSearchResult = await searchFromShell(searchSecondString)
                if (shellSecondSearchResult.equipment_list?.equipment?.length) {
                    setSearchModellField(searchSecondString)
                    return;
                } else {
                    toast.current.show({ severity: 'warn', detail: 'На жаль, не змогли знайти в базі детальну інформацію за ТЗ, спробуйте вручну, використовуючи фільтри', life: 3000 });
                    setDetailSearchMode(true)
                    setSearchModellField(car.CarBrand)
                }
            }
        }
        else{
            toast.current.show({ severity: 'warn', detail: 'На жаль, не знайдено жодного ТС за номером ', life: 3000 });
        }
    }

    const handleGetRecommendations = async () => {
        setRecommendationLoading(true);
        setHasSearchedRecommendations(true);
        try {
            // existing function performs the actual request and updates recommendationList
            await onClickMatchShellLubricants();
        } finally {
            setRecommendationLoading(false);
        }
    }

    const onClickMatchShellLubricants = async () => {
        setDetailSearchMode(false);
        const resultJson = await lubeMatchAPI.getCarRecommendation(currentCar['@href'], searchVinNumberField?.toLocaleUpperCase(), searchModelField?.toLocaleUpperCase())
        const result = JSON.parse(resultJson.data);
        if(result.length){
            setRecommendationList(result);
        }
        else
            setRecommendationList([])

    }

    const searchFromShell = async (inputString, CarSeriesOption, FuelTypeOption, EngineDisplacementOption, CarMakeYearOption) => {
        const params = {
            language: 'uk',
            q: inputString,
            page: 1,
            page_size: 50,
            series: CarSeriesOption,
            fueltype: FuelTypeOption,
            displacement: EngineDisplacementOption,
            year: CarMakeYearOption
        }
        debugger
        const shellResult = await searchWithDynamicQuery(params)
        const list = shellResult?.equipment_list?.equipment || [];
        setSearchedCarListByModel(list);

        if (shellResult?.facets?.series?.buckets)
        setCarSeriesOptions(mapFacetToOptions(shellResult.facets.series));

        if (shellResult?.facets?.fueltype?.buckets)
        setFuelTypeOptions(mapFacetToOptions(shellResult.facets.fueltype));

        if (shellResult?.facets?.year?.buckets)
        setCarMakeYearOptions(mapFacetToOptions(shellResult.facets.year));

        if (shellResult?.facets?.displacement?.buckets)
        setEngineDisplacementOptions(mapFacetToOptions(shellResult?.facets?.displacement));

        return shellResult;
    }
   

    // hide suggestions on outside click
    const modelBlockRef = useRef(null);
    useEffect(() => {
        const onDocClick = (e) => {
            if (!modelBlockRef.current) return;
        };
        document.addEventListener('mousedown', onDocClick);
        return () => document.removeEventListener('mousedown', onDocClick);
    }, []);

    const onSelectCar = (car) => {
        setCurrentCar(car);
        setSearchModellField(car?.display_name_long || car?.model || '');
        setSearchedCarListByModel([]);
    }

    return (
        <div className={styles.lubematchSearchWrapper}>
            <Toast ref={toast} />
            <div className={`${styles.search} ${styles.grid}`}>
                <div className={styles.card}>
                    <div className={styles.modelSearchBlock}>
                        <span className={styles.inputLabel}>Пошук за VIN / номером</span>
                        <div className={styles.vinInputButton}>
                            <InputText style={{ width: '100%' }} placeholder="1G1FW69M71AXXXXXX або AА1234АА" value={searchVinNumberField} onChange={(e) => setSearchVinNumberField(e.target.value)} className={styles.vinNumberSearchInput} />
                            <Button className={styles.searchButton} style={{ borderRadius: '5px' }} label="Пошук" icon="pi pi-search" loading={loading} rounded={true} onClick={onClickVinNumberSearch} />
                        </div>
                        <span style={{color:'#6d6d6d'}}>Після пошуку, буде запропоновано обрати модель з бази SHELL</span>
                    </div>
                    <div className={styles.modelSearchBlock} ref={modelBlockRef}>
                        <span className={styles.inputLabel}>Пошук моделі авто</span>
                        <div>
                            <div style={{display:"flex", flexDirection: "column", gap: "10px"}}>
                                {detailSearchMode && <div className={styles.filtersWrapper}>
                                    <Dropdown value={selectedCarSeriesOption} onChange={(e) => setSelectedCarSeriesOption(e.value)} options={carSeriesOptions} optionLabel="name" optionValue="value" placeholder="Модель" showClear filter filterPlaceholder="Пошук..." className="" />
                                    <Dropdown value={selectedFuelTypeOption} onChange={(e) => setSelectedFuelTypeOption(e.value)} options={fuelTypeOptions} optionLabel="name" optionValue="value" placeholder="Тип двигуна" showClear filter filterPlaceholder="Пошук..." className="" />
                                    <Dropdown value={selectedCarMakeYearOption} onChange={(e) => setSelectedCarMakeYearOption(e.value)} options={carMakeYearOptions} optionLabel="name" optionValue="value" placeholder="Рік випуску" showClear filter filterPlaceholder="Пошук..." className="" />
                                    <Dropdown value={selectedEngineDisplacementOption} onChange={(e) => setSelectedEngineDisplacementOption(e.value)} options={engineDisplacementOptions} optionLabel="name" optionValue="value" placeholder="Об'єм двигуна" showClear filter filterPlaceholder="Пошук..." className="" />

                                </div>}
                                <InputText
                                    style={{ width: '100%' }}
                                    value={searchModelField}
                                    onChange={(e) => setSearchModellField(e.target.value)}
                                    placeholder="M340i xDrive G20 Petrol 387bhp (Б) (2019-)"
                                    className={styles.modelSearchInput}
                                />
                            </div>
                            {searchedCarListByModel?.length > 0 && (
                                <div className={styles.modelSuggestions}>
                                    {searchedCarListByModel.map((car, idx) => (
                                        <div
                                            key={car?.id || car?.uuid || car?.display_name_long || car?.model || idx}
                                            className={styles.modelSuggestionItem}
                                            onClick={() => onSelectCar(car)}
                                        >
                                            {car?.display_name_long}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                        <Button className={styles.getRecommendationButton} style={{ borderRadius: '5px' }} disabled={!currentCar} label="Підібрати мастило" icon="pi pi-search" rounded={true} onClick={handleGetRecommendations} />
                    </div>
                </div>
            </div>
            <div>
                <LubematchRecommendation recommendationList={recommendationList} hasSearched={hasSearchedRecommendations} loading={recommendationLoading} />
            </div>
        </div>
    )
}

